export interface StatusInfo {
  label: string;
  color: string;
}

// Status colors follow the Visual Toolkit palette (purple, blue, gold, grey, red).
// submitted uses toolkit gold (#F2A900) — a holding state awaiting Ops;
// pre_review uses toolkit blue (#0085DC); irb_review uses pink (#8F3BAC) —
// nothing else in the palette is pink, making it immediately distinct.
export const STATUS_COLORS = {
  draft: '#300091',
  submitted: '#F2A900',
  pre_review: '#0085DC',
  irb_review: '#8F3BAC',
  post_review: '#717680',
  withdrawn: '#9ca3af',
  deleted: '#6b7280',
  complete: '#10b981',
  expired: '#9ca3af',
  response_required: '#ef4444',
  expiring_soon: '#f59e0b',
} as const;

const STATUS_MAP: Record<string, StatusInfo> = {
  draft: { label: 'Draft', color: STATUS_COLORS.draft },
  submitted: { label: 'Submitted', color: STATUS_COLORS.submitted },
  pre_review: { label: 'Pre-review', color: STATUS_COLORS.pre_review },
  irb_review: { label: 'IRB Review', color: STATUS_COLORS.irb_review },
  post_review: { label: 'Post-review', color: STATUS_COLORS.post_review },
  withdrawn: { label: 'Withdrawn', color: STATUS_COLORS.withdrawn },
  deleted: { label: 'Deleted', color: STATUS_COLORS.deleted },
  complete: { label: 'Complete', color: STATUS_COLORS.complete },
  expired: { label: 'Expired', color: STATUS_COLORS.expired },
};

const QUICK_FILTER_MAP: Record<string, StatusInfo> = {
  response_required: {
    label: 'Response Required',
    color: STATUS_COLORS.response_required,
  },
  expiring_soon: { label: 'Expiring Soon', color: STATUS_COLORS.expiring_soon },
};

const DEFAULT_STATUS: StatusInfo = { label: '', color: '#717680' };

export const getStatusInfo = (status: string): StatusInfo => {
  return (
    STATUS_MAP[status] ??
    QUICK_FILTER_MAP[status] ?? { ...DEFAULT_STATUS, label: status }
  );
};

export const STATUS_OPTIONS = Object.entries(STATUS_MAP).map(
  ([value, { label }]) => ({ value, label })
);
